var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('AwHeader',{class:_vm.index_header}),_c('div',{staticClass:"banner-wrap"},[_c('Banner',{attrs:{"BannerHeight":_vm.BannerHeight}}),_c('over-lay')],1),_c('index-service'),_c('AwFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }